import React from 'react';
import { motion } from 'framer-motion';
import { aboutImage1, aboutImage2 } from '../data/mock';

const About = () => {
  return (
    <section id="about" className="relative py-20 md:py-32">
      <div className="max-w-6xl mx-auto px-6 md:px-10 space-y-24 md:space-y-32">
        {/* Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9 }}
          >
            <p
              className="text-white/80 tracking-[0.3em] text-xs md:text-sm font-light mb-4"
              style={{ fontFamily: "'Josefin Sans', sans-serif" }}
            >
              OUR MISSION
            </p>
            <h2
              className="text-white font-light leading-tight mb-6"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: 'clamp(1.9rem, 3.5vw, 3rem)',
              }}
            >
              In our world, wellness is more than a service, it&apos;s a lifestyle.
            </h2>
            <div className="w-16 h-px bg-white/50 mb-6" />
            <p
              className="text-white/95 leading-relaxed text-base md:text-lg font-light"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              At <em>Blissfull Mobile Spa</em>, we&apos;re not just about spa services; we&apos;re about crafting an experience as unique as you are. Picture a world where stress melts away, and your spirit dances with joy. That&apos;s the vision we&apos;re painting &mdash; leaving you not just relaxed but revitalized and refreshed, ready to embrace the sunshine in your soul.
            </p>
            <p
              className="text-white/90 leading-relaxed text-base md:text-lg font-light mt-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Your well-being is our passion, and your joy is our mission.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9 }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-white/10 rounded-3xl blur-2xl" />
            <img
              src={aboutImage1}
              alt="Blissful spa treatment"
              className="relative rounded-3xl w-full h-[420px] md:h-[520px] object-cover shadow-2xl"
              loading="lazy"
            />
          </motion.div>
        </div>

        {/* Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9 }}
            className="relative md:order-1 order-2"
          >
            <div className="absolute -inset-4 bg-white/10 rounded-3xl blur-2xl" />
            <img
              src={aboutImage2}
              alt="Serene spa moment"
              className="relative rounded-3xl w-full h-[420px] md:h-[520px] object-cover shadow-2xl"
              loading="lazy"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9 }}
            className="md:order-2 order-1"
          >
            <p
              className="text-white/80 tracking-[0.3em] text-xs md:text-sm font-light mb-4"
              style={{ fontFamily: "'Josefin Sans', sans-serif" }}
            >
              OUR VISION
            </p>
            <h2
              className="text-white font-light leading-tight mb-6"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: 'clamp(1.9rem, 3.5vw, 3rem)',
              }}
            >
              Let&apos;s transform chaos into moments of tranquility and connection.
            </h2>
            <div className="w-16 h-px bg-white/50 mb-6" />
            <p
              className="text-white/95 leading-relaxed text-base md:text-lg font-light"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Step into the enchanting world of <em>Blissfull Mobile Spa</em>, where every visit is a transformative journey towards holistic wellness. We aspire to be your haven, addressing not just your physical well-being but also providing a nurturing space for emotional and mental support.
            </p>
            <p
              className="text-white leading-relaxed text-base md:text-lg font-light mt-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Here, you&apos;re not just a client &mdash; you&apos;re a cherished member of our community.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
